import type { ReactNode } from 'react';

interface CpmCardProps {
    children: ReactNode;
    /** Inner padding when the card has no self-padded rows (e.g. table-only cards). Default 0 — most list/detail cards compose their own padded rows. */
    padding?: number;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Primary containing surface — design's two-radius rule: 16px card radius,
 * 1px hairline border, navy-tinted card shadow. Matches the design system's
 * `Card` component exactly (see docs2 `_ds_bundle.js`).
 */
export default function CpmCard({ children, padding = 0, className = '', style }: CpmCardProps) {
    return (
        <div
            className={['bg-white overflow-hidden', className].join(' ')}
            style={{
                border: '1px solid var(--cpm-border-default)',
                borderRadius: 'var(--cpm-radius-2xl)',
                boxShadow: 'var(--cpm-shadow-card)',
                padding,
                ...style,
            }}
        >
            {children}
        </div>
    );
}
